/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_SignupsInputs */

const en_admin_funnel_history_signups = /** @type {(inputs: Admin_Funnel_History_SignupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-ups`)
};

/**
* | output |
* | --- |
* | "Sign-ups" |
*
* @param {Admin_Funnel_History_SignupsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_signups = /** @type {((inputs?: Admin_Funnel_History_SignupsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_SignupsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_signups(inputs)
});
export { admin_funnel_history_signups as "admin.funnel.history.signups" }